export default "__VITE_ASSET__Ch1mF7Tt__"